// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__43YUt","primaryInverse":"Button_primaryInverse__8qHVP","secondary":"Button_secondary__IFxpA","secondaryInverse":"Button_secondaryInverse__zPA6H"};